import React from "react";

export default function SectionTitle({ title }: { title?: string }) {
    if (!title) {
        return null;
    }
    return (
        <div
            className="section-title"
            dangerouslySetInnerHTML={{ __html: title }}
        />
    );
}
